/*
* @Description: file content
* @Version: file content
* @Author: hujunke
* @Date: 2023-11-13 10:20
* @LastEditors:
* @LastEditTime: 2023-11-13 10:20
*/
// 记录当前应用app状态 是否展示回首页操作
const state = {
  isGoHome: false,
  currentApp: '', // 当前进入的应用模块
};

const mutations = {
  SET_GO_HOME: (state, isGoHome) => {
    state.isGoHome = isGoHome;
  },
  SET_CURRENT_APP: (state, currentApp) => {
    state.currentApp = currentApp;
  },
};
const actions = {
  SET_GO_HOME(context, isGoHome) {
    context.commit('SET_GO_HOME', isGoHome);
  },
  SET_CURRENT_APP(context, currentApp) {
    context.commit('SET_CURRENT_APP', currentApp);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
